const PATH_BASE = "/promote";
export const BUSINESS_PATH = `${PATH_BASE}/business`;
export const SUB_CATEGORY_PATH = `${PATH_BASE}/sub-category`;
export const FIRST_NAME_PATH = `${PATH_BASE}/first-name`;
export const LAST_NAME_PATH = `${PATH_BASE}/last-name`;
export const ROLE_PATH = `${PATH_BASE}/role`;
export const CONTACT_PHONE_PATH = `${PATH_BASE}/contact-phone`;
export const LAYOUT_PATH = `${PATH_BASE}/layout`;
export const CAPTION_PATH = `${PATH_BASE}/caption`;
export const ADDRESS_PATH = `${PATH_BASE}/address`;
export const CITY_PATH = `${PATH_BASE}/city`;
export const STATE_PATH = `${PATH_BASE}/state`;
export const ZIP_PATH = `${PATH_BASE}/zip`;
export const PHONE_PATH = `${PATH_BASE}/phone`;
export const WEBSITE_PATH = `${PATH_BASE}/website`;
export const FACEBOOK_PATH = `${PATH_BASE}/facebook`;
export const TWITTER_PATH = `${PATH_BASE}/twitter`;
export const INSTAGRAM_PATH = `${PATH_BASE}/instagram`;
export const ABOUT_PATH = `${PATH_BASE}/about`;
export const EMAIL_PATH = `${PATH_BASE}/email`;
export const ADDITIONAL_TEXT_PATH = `${PATH_BASE}/additional-text`;
export const WIDGET_SELECTION_PATH = `${PATH_BASE}/widget`;
export const DURATION_SELECTION_PATH = `${PATH_BASE}/duration`;
export const START_DATE_SELECTION_PATH = `${PATH_BASE}/start-date`;
export const PAYMENT_INFORMATION_PATH = `${PATH_BASE}/payment-information`;
export const ORDER_CONFIRMATION_PATH = `${PATH_BASE}/order-confirmation`;
export const WRAP_UP_PATH = `${PATH_BASE}/wrap-up`;

export const ENTRYPOINT_PATH = LAYOUT_PATH;
